<template>
  <div class="register-item">
    <!-- <div slot="title" class="login-header">复投财经</div> -->
    <template>
   
      <el-form ref="loginForm2" :model="reqData2" :rules="loginForm2Rules" class="login-form" label-position="left"
       >
        <el-form-item prop="Mobile" class="login-form-item">
          <el-input v-model="form.phone" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item prop="Code" class="login-form-item">
          <el-input v-model="reqData2.Code" prefix-icon="el-icon-connection" placeholder="请输入验证码" />
          <el-button type="text" v-if="verControl" :disabled="smsDisabled" class="btn_sms"
            @click="verCode(form.phone)">{{ '获取验证码' }}</el-button>
          <el-button type="text" v-else :disabled="smsDisabled" class="btn_sms">{{ '重新获取' + (verSecond) }}</el-button>
        </el-form-item>
        <el-form-item prop="Pwd" class="login-form-item">
          <el-input v-model="reqData2.Pwd" prefix-icon="el-icon-lock" show-password type="password"
            placeholder="请输入账号密码" @keyup.enter.native="newhandleSubmit" />
        </el-form-item>
        <p @click.stop="goLogin" class="goLogin">已有账号,马上登录</p>
        <el-form-item label-width="0">
          <div class="login-form-btn" @click.stop="newhandleSubmit">注册</div>
        </el-form-item>
        <p class="accept">我已阅读和接受<span @click="userAgreement">《用户协议》</span></p>
      </el-form>



    </template>

  </div>
</template>
<script>

import userSign from '@/mixins/userSign';
import { encryptCBC, appCode, getIMEI, getIpConfig } from "@/utils/IMEI";


export default {
  mixins: [userSign],

  data() {
    return {
      activeName: 'first',
      smsTime: 60,
      reqData2: {
        Mobile: '',
        Pwd: '',
        Code: '',
        device: 'pc',
        plats:[{
          id:1,
        }]
      },
      smsDisabled: false,
      smsBtnText: '获取验证码',
      loginForm2Rules: {
        // Mobile: [
        //   { required: true, message: '手机号不能为空', trigger: 'blur' }
        // ],
        Pwd: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        Code: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      },
      form: {
        phone: '',
        code: '',
      },

    }
  },
  computed: {
    dialogObj() {
      return this.$store.state.home.dialogObj
    },
    controlActiveName(){
      return this.$store.state.login.activeName
    },
    registerStatus(){
      return this.$store.state.login.isPc
    }
    
  },
  watch: {
    'dialogObj.dialogVisible'(newVal) {
      if (!newVal) {
        // this.$refs['loginForm'].resetFields()
        this.$refs['loginForm2'].resetFields()
      }
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    },
    async _getSms() {
      const params = {
        phone: this.reqData2.phone
      }
      const res = await this.$store.dispatch('login/handleSms', params)
      console.log(res)
      setInterval(() => {
        this.smsBtnText = this.smsTime + '秒后重新获取'
        this.smsTime--
        if (this.smsTime < 0) {
          this.smsBtnText = '获取验证码'
          this.smsDisabled = false
          clearInterval()
        }
      }, 1000)
    },
    // 提交注册
    handleSubmit() {
      this.$refs['loginForm2'].validate(async valid => {
        if (valid) {
          await this.$store.dispatch('login/handleRegister', this.reqData2);
          this.$refs['loginForm2'].resetFields();
          this.$store.commit('home/set_dialogobj', { dialogVisible: false });
        }
      })
    },
    // craig--新增注册
    newhandleSubmit() {
      this.$refs['loginForm2'].validate(async valid => {
        if (valid) {
          const isWap = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
          let data = {
            ...ipInfo,
            appcode: appCode()['channel'] || appCode()['v'] || '5100',
            fromType: isWap ? 'wap' : 'pc',
            isMt5: 1,
            clientId: getIMEI(),
            mobile: this.form.phone,
            code: this.reqData2.Code,
            email: this.form.email||'',
            pwd: this.reqData2.Pwd ? encryptCBC(this.reqData2.Pwd) : undefined,
          };
          const ipInfo = await getIpConfig();
          this.$store.commit('home/set_userPwd',this.reqData2.Pwd)
          await this.$store.dispatch('login/handleRegister', data);
          this.$refs['loginForm2'].resetFields();
          this.$store.commit('home/set_dialogobj', { dialogVisible: false });
        }
      })
    },
  
   
    goLogin(){
      this.$store.commit('login/set_activeName', 'second');
    },
    userAgreement(){
      window.open('https://www.rlcproltd.net/uc/userAgreement');
    }
  }
}
</script>

<style lang="less">
.register-item {
  .login-header {
    text-align: center;
    font-size: 22px;
    color: #3498db;
    margin-top: -50px;
    line-height: 40px;
  }
  .login-form {
    margin-top: 30px;
    .login-form-item {
      width: 81%;
      margin: 15px auto;
      padding: 0 10px;
      line-height: 40px;
      border-radius: 5px;
      font-size: 16px;
      border: 1px solid #c0c4cc;
      .el-form-item__label {
        text-align: center !important;
        color: #394d62;
        font-size: 16px;
      }
      input {
        flex: 1;
        font-size: 16px;
        color: #394d62;
        outline: none;
        border: none;
      }
    }
    .btn_sms{
      position: absolute;
      right: 0;
    }
    .login-form-btn {
      width: 85%;
      margin: 30px auto 0;
      background-color: #f22118;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 50px;
      font-size: 18px;
      border-radius: 8px;
      cursor: pointer;
      height: 50px;
    }
    .goLogin{
      width: 85%;
      margin: 0 auto 15px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .accept{
      width: 85%;
      margin: 0 auto;
      span{
        color: #35a2ff;
        cursor: pointer;
      }
    }
  }
}
</style>
